// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__1NnEV","select__error":"styles_select__error__2UYr4"};